export default {
  component: {
    jobAdList: {
      title: '채용 중인 직책',
      jobs: '채용 정보',
      noJobAds: '현재 채용 중인 직책이 없습니다.',
    },

    jobAdCard: {
      openUntil: date => `${date}까지 채용 진행`,
    },

    jobAdGreetings: {
      thankYou: '감사합니다.',
      readyInfo: '지원서가 접수되었습니다. 채용 담당자가 곧 연락드리겠습니다.',
      luck: '행운을 빕니다!',
    },

    jobAdSeeYou: {
      title: '감사합니다.',
      description:
        '지원서가 저장되었으며 나중에 계속 지원하실 수 있도록 링크를 보내드렸습니다.',
    },

    unpublished: {
      title: '게시되지 않음',
      info: '채용 공고가 아직 게시되지 않았습니다.',
    },
  },
}
